module.exports = __webpack_public_path__ + "img/slide1.a0f61d21.png";